import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./TauriApplicationMenuItems.css";

const TauriApplicationMenuItems = ({ items }) => {
    const location = useLocation();
    const currentPath = location.pathname;

    return (
        <ul className="tauri-application-menu navbar-nav d-flex flex-row tauri-menu-container w-100">
            {items.map((item, idx) => {
                // Check if the current path starts with the item's path
                const isActive =
                    currentPath === item.path || currentPath.startsWith(`${item.path}/`);

                return (
                    <li className="nav-item" key={idx}>
                        <Link
                            to={item.path}
                            className={`nav-link tauri-menu-item ${isActive ? "active" : ""}`}
                        >
                            <img
                                src={process.env.PUBLIC_URL + item.icon}
                                alt={item.name}
                                className="tauri-menu-icon me-2"
                            />
                            {item.name}
                        </Link>
                    </li>
                );
            })}
        </ul>
    );
};

export default TauriApplicationMenuItems;
